import type { WallMicState, WallNocConfig } from "@/types/ai-assistant-voice";
import { createMicGate } from "./voice-mic-gate";

/**
 * Menghubungkan gerbang mikrofon Mode NOC ke perangkat nyata: `track.enabled`
 * pada mikrofon (sesi GPT-Live tetap terbuka) dan `volume` elemen audio Jenna.
 */

export interface WallMic {
	press(): void;
	release(): void;
	/** Satu sampel audio Jenna terdengar (dari pengukur level suara jauh). */
	audible(): void;
	/** Tombol bisukan mikrofon manual user; tidak pernah membuka paksa mic. */
	setUserMuted(muted: boolean): void;
	stop(): void;
}

interface Options {
	mic: MediaStream;
	remote: HTMLAudioElement;
	config: WallNocConfig;
	/** Interupsi sengaja lewat tombol bicara: hentikan giliran Claude yang berjalan. */
	onBargeIn(): void;
	onState(state: WallMicState): void;
}

const PERCENT = 100;

export function createWallMic(o: Options): WallMic {
	const level = o.config.volume / PERCENT;
	let userMuted = false;
	let gateOpen = false;
	const apply = () => {
		for (const track of o.mic.getAudioTracks())
			track.enabled = gateOpen && !userMuted;
	};
	o.remote.volume = level;
	const gate = createMicGate({
		mode: o.config.micMode,
		settleMs: o.config.settleMs,
		setOpen(open) {
			gateOpen = open;
			apply();
		},
		onBargeIn(active) {
			// Memotong suara Jenna di pemutar lokal; model berhenti sendiri saat mendengar user.
			o.remote.volume = active ? 0 : level;
			if (active) o.onBargeIn();
		},
		onState: o.onState,
	});
	return {
		press: gate.press,
		release: gate.release,
		audible: gate.audible,
		setUserMuted(muted) {
			userMuted = muted;
			apply();
		},
		stop: gate.stop,
	};
}
